import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

import { getTest, fetchTest } from 'store/testReducer';
import TestForm from './TestForm/TestForm';
import Spin from 'components/ui/Spin';
import api from 'core/utils/api';
import * as notify from 'components/ui/Notify/store/actions';
import TestNextSteps from './TestNextSteps';

class TestEditContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      complete: false,
    }
  }

  componentDidMount() {
    const { match } = this.props;
    this.props.fetchTest(match.params.id);
  }

  handleSubmit = (test, complete = false) => {
    const { notifySuccess, history } = this.props;
    const { id } = test;

    api.put(`/tests/${id}`, { test, complete })
      .then(() => {
        notifySuccess('Test was successfully updated.');

        if (complete) {
          this.setState({ complete });
        } else {
          history.push('/tests');
        }
      });
  }

  renderTestForm = (test, complete) => {
    if (complete) {
      return null;
    }

    return (
      <TestForm
        onSubmit={this.handleSubmit}
        initialValues={test}
      />
    );
  }

  renderNextSteps = (test, complete) => {
    if (!complete) {
      return null;
    }

    return (
      <TestNextSteps
        test={test}
      />
    );
  }

  render() {
    const { test } = this.props;
    const { complete } = this.state;

    if (isEmpty(test)) {
      return <Spin />;
    } else {
      return (
        <div>
          {this.renderTestForm(test, complete)}
          {this.renderNextSteps(test, complete)}
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.match.params.id;
  return {
    test: getTest(state, id),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators({
    fetchTest,
    notifySuccess: notify.actions.success,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TestEditContainer);



// WEBPACK FOOTER //
// ./src/features/test/TestEditContainer.js